/*
  tk-track.js - jednotna vrstva eventu pro Google Tag Manager (window.dataLayer).

  Ucel: markeťák si v GTM nastavi trigger typu "Custom Event" na nazev eventu
  a promenne typu "Data Layer Variable" na parametry. Nic se nescrapuje z DOMu
  v GTM, vsechno posila theme s pevne danymi nazvy. Kompletni seznam eventu
  a parametru: .claude/notes/features.md -> "GTM tracking eventy" (a stranka
  pro markeťáka, odkaz tamtez).

  Jak to funguje:
    1. DEKLARATIVNE - element v Liquidu nese data-tk-ev="nazev_eventu" a
       parametry jako data-tk-ev-<param>="hodnota" (data-tk-ev-position="hp_hero"
       -> { position: "hp_hero" }). Klik na nej (nebo na cokoliv uvnitr) posle
       event. Pomlcky v nazvu parametru se prevedou na podtrzitka.
       data-tk-view="banner_view" + stejne data-tk-ev-* parametry = event pri
       zobrazeni (IntersectionObserver, 50 % plochy, jednou za nacteni stranky;
       u rotatoru znovu pro kazdy slide, ktery se stane aktivnim).
    2. PRAVIDLY (RULES nize) - selektory pro prvky, kde data atributy nedavaji
       smysl (product karty, mega menu, Globo filtry, Judge.me, galerie...).
    3. UDALOSTMI THEME - variant:update, cart:update, cart:error, discount
       (tk:coupon z cart-discount.js), tk:newsletter-signup (popup),
       toggle na <details>, otevreni cart draweru, zmena URL (filtry/razeni).

  Kazdy event = DVA pushe (format podle zadani marketera, soubor "DL push priklad"):
    dataLayer.push({ custom_data: null });
    dataLayer.push({ event: "<nazev>", event_source: "theme", custom_data: { ...parametry } });
  V GTM se parametr cte jako Data Layer Variable "custom_data.position" atd.
  Null pred kazdym eventem vynuluje parametry predchoziho (GTM merguje rekurzivne).

  Ladeni: pridej do URL ?tk_track_debug=1 (drzi se v sessionStorage), eventy
  se pak vypisuji do konzole jako [tk-track]. Vypnuti: ?tk_track_debug=0.
  Nebo GTM Preview - tam je videt dataLayer primo.

  Soubor NESMI obsahovat Liquid, servíruje se jako staticky asset.
*/
(function () {
  'use strict';

  if (window.__tkTrackLoaded) return;
  window.__tkTrackLoaded = true;

  var cfg = window.__tkTrack || {};
  var dl = (window.dataLayer = window.dataLayer || []);
  var debug = false;

  try {
    var qp = new URLSearchParams(location.search).get('tk_track_debug');
    if (qp === '1') sessionStorage.setItem('tk_track_debug', '1');
    if (qp === '0') sessionStorage.removeItem('tk_track_debug');
    debug = sessionStorage.getItem('tk_track_debug') === '1';
  } catch (e) {}

  /* ------------------------------------------------------------------ */
  /* Push do dataLayer                                                    */
  /* ------------------------------------------------------------------ */
  function push(name, params) {
    if (!name) return;
    params = params || {};
    var data = {};
    Object.keys(params).forEach(function (k) {
      var v = params[k];
      if (v === '' || v === null || typeof v === 'undefined') return;
      data[k] = v;
    });
    /* Reset pred kazdym eventem (format dle zadani marketera): GTM merguje
       dataLayer rekurzivne, bez null by parametry predchoziho eventu visely dal. */
    dl.push({ custom_data: null });
    dl.push({ event: name, event_source: 'theme', custom_data: data });
    if (debug) console.debug('[tk-track]', name, data);
    try {
      document.dispatchEvent(new CustomEvent('tk:track', { detail: { event: name, params: data } }));
    } catch (e) {}
  }
  window.tkTrack = push;

  /* ------------------------------------------------------------------ */
  /* Pomocne funkce                                                       */
  /* ------------------------------------------------------------------ */
  function txt(el, max) {
    if (!el) return '';
    var s = (el.getAttribute && el.getAttribute('aria-label')) || '';
    if (!s) s = el.textContent || '';
    s = s.replace(/\s+/g, ' ').trim();
    max = max || 80;
    return s.length > max ? s.slice(0, max) : s;
  }

  function slug(s) {
    s = String(s || '');
    try {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) {}
    return s
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 60);
  }

  function hrefOf(el) {
    var a = el && el.closest ? el.closest('a[href]') : null;
    if (!a) return '';
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      return u.pathname + u.search;
    } catch (e) {
      return a.getAttribute('href') || '';
    }
  }

  function collectionHandle(href) {
    var m = /\/collections\/([^/?#]+)/.exec(href || '');
    return m ? m[1] : '';
  }

  function productHandle(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? m[1] : '';
  }

  function sectionId(el) {
    var s = el && el.closest ? el.closest('.shopify-section') : null;
    return s ? s.id.replace(/^shopify-section-/, '') : '';
  }

  function listOf(el) {
    var l = el && el.closest ? el.closest('[data-tk-list]') : null;
    if (l) return l.getAttribute('data-tk-list');
    if (cfg.template === 'collection' && cfg.collection) return cfg.collection;
    if (cfg.template === 'search') return 'search';
    var sid = sectionId(el);
    if (/recommendations/.test(sid)) return 'recommendations';
    return sid || cfg.template || '';
  }

  function evParams(el) {
    var p = {};
    var ds = el.dataset || {};
    Object.keys(ds).forEach(function (k) {
      if (k.indexOf('tkEv') !== 0 || k.length <= 4) return;
      var key = k
        .slice(4)
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase()
        .replace(/^_/, '');
      p[key] = ds[k];
    });
    if (!p.url && el.tagName === 'A') p.url = hrefOf(el);
    return p;
  }

  function productFromCard(card) {
    var p = {};
    p.product_id = card.getAttribute('data-product-id') || '';
    var link = card.querySelector('.product-card__link');
    p.product_name = txt(link) || txt(card.querySelector('.product-title, .product-card__title'));
    p.product_handle = productHandle(hrefOf(link || card.querySelector('a[href*="/products/"]')));
    var scope = card.closest('[data-tk-list], .shopify-section') || document;
    var cards = scope.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i] === card) {
        p.position = i + 1;
        break;
      }
    }
    p.list = listOf(card);
    return p;
  }

  function inHeader(el) {
    return !!el.closest('.tk-header, .tk-announce, tk-announcement, .tk-mobile-drawer, .shopify-section-group-header-group');
  }

  function contactType(href) {
    if (/^mailto:/i.test(href)) return 'email';
    if (/^tel:/i.test(href)) return 'telefon';
    return '';
  }

  function finderValues(changedEl) {
    var dev = document.querySelector('#tk-finder-device .tk-finder__value');
    var cat = document.querySelector('#tk-finder-category .tk-finder__value');
    var v = {
      device: dev && !dev.classList.contains('tk-finder__value--placeholder') ? txt(dev) : '',
      category: cat && !cat.classList.contains('tk-finder__value--placeholder') ? txt(cat) : '',
    };
    if (changedEl) {
      var sel = changedEl.closest('.tk-finder__select');
      if (sel && sel.id === 'tk-finder-device') v.device = txt(changedEl);
      if (sel && sel.id === 'tk-finder-category') v.category = txt(changedEl);
    }
    return v;
  }

  /* ------------------------------------------------------------------ */
  /* Pravidla pro kliky (poradi = priorita, prvni shoda vyhrava)          */
  /* ------------------------------------------------------------------ */
  var RULES = [
    /* Newsletter teaser "10 % pro tebe" */
    {
      sel: '[data-tk-popup-dismiss]',
      fn: function () {
        push('promo_ribbon_dismiss', {});
      },
    },
    {
      sel: '.tk-popup__teaser',
      fn: function () {
        push('promo_ribbon_click', {});
      },
    },

    /* Finder "Pro / Potrebuju" */
    {
      sel: '.tk-finder__option',
      fn: function (el) {
        var v = finderValues(el);
        var sel = el.closest('.tk-finder__select');
        v.changed = sel && sel.id === 'tk-finder-device' ? 'device' : 'category';
        push('product_finder_used', v);
      },
    },
    {
      sel: '#tk-finder-btn',
      when: function (el) {
        return el.getAttribute('aria-disabled') !== 'true';
      },
      fn: function (el) {
        var v = finderValues(null);
        v.url = hrefOf(el);
        push('product_finder_submit', v);
      },
    },

    /* Recenze (Judge.me badge, preview sekce, tab Recenze) */
    {
      sel: '[data-jdgm-preview-badge], .tk-reviews-preview__header-link, .tk-reviews-preview__card-link, .tk-reviews-preview__translate, .product-tabs__tab[data-tab-name="reviews"]',
      fn: function (el) {
        var src = 'badge';
        if (el.classList.contains('product-tabs__tab')) src = 'tab';
        else if (el.className.indexOf('tk-reviews-preview') >= 0) src = 'preview';
        push('reviews_click', { source: src, product_id: cfg.product ? cfg.product.id : '' });
      },
    },

    /* Taby na PDP (Vlastnosti / Parametry / Baleni / Videa / Ke stazeni) */
    {
      sel: '.product-tabs__tab',
      fn: function (el) {
        push('accordion_open', { name: el.getAttribute('data-tab-name') || slug(txt(el)), type: 'tab' });
      },
    },

    /* Doprava */
    {
      sel: '.tk-shipopt__trigger',
      when: function (el) {
        return el.getAttribute('aria-expanded') !== 'true';
      },
      fn: function () {
        push('shipping_info_click', { source: 'pdp_options' });
      },
    },
    {
      sel: '.tk-shipopt__link',
      fn: function (el) {
        push('shipping_info_click', { source: 'pdp_options_link', url: hrefOf(el) });
      },
    },

    /* Kontakt */
    {
      sel: '[data-inquiry-open]',
      fn: function () {
        push('contact_click', { type: 'inquiry', location: 'pdp', product_id: cfg.product ? cfg.product.id : '' });
      },
    },
    {
      sel: '.tk-header__info-copy',
      fn: function () {
        push('nav_click', { label: 'email_copy' });
      },
    },
    {
      sel: 'a[href^="mailto:"], a[href^="tel:"]',
      fn: function (el) {
        var type = contactType(el.getAttribute('href'));
        if (inHeader(el)) push('nav_click', { label: type });
        else push('contact_click', { type: type, location: sectionId(el) || cfg.template });
      },
    },
    {
      sel: 'a[href*="/pages/kontakt"]',
      fn: function (el) {
        if (inHeader(el)) push('nav_click', { label: 'kontakt', url: hrefOf(el) });
        else push('contact_click', { type: 'page', location: sectionId(el) || cfg.template, url: hrefOf(el) });
      },
    },

    /* Horni lista - Akce */
    {
      sel: '.tk-nav__link--sale, .tk-drawer-panel__item--sale',
      fn: function (el) {
        push('nav_click', { label: 'akce', url: hrefOf(el) });
      },
    },

    /* Odkazy na dopravu mimo hlavicku (v hlavicce = nav_click z Liquidu) */
    {
      sel: 'a[href*="doprava"]',
      when: function (el) {
        return !inHeader(el);
      },
      fn: function (el) {
        push('shipping_info_click', { source: 'link', location: sectionId(el) || cfg.template, url: hrefOf(el) });
      },
    },

    /* Checkout tlacitko (drawer i /cart) */
    {
      sel: 'button[name="checkout"], #checkout',
      fn: function (el) {
        push('checkout_step', {
          step: 3,
          step_name: 'checkout_click',
          location: el.closest('cart-drawer-component') ? 'cart_drawer' : 'cart_page',
        });
      },
    },

    /* Vysledky hledani - naseptavac */
    {
      sel: 'predictive-search-component a[href]',
      when: function (el) {
        return !!el.closest('[ref="predictiveSearchResults"], [data-search-results]');
      },
      fn: function (el) {
        var input = document.querySelector('predictive-search-component input[name="q"]');
        var href = hrefOf(el);
        var type = 'other';
        if (/\/products\//.test(href)) type = 'product';
        else if (/\/collections\//.test(href)) type = 'collection';
        else if (/\/search/.test(href)) type = 'query';
        else if (/\/blogs\//.test(href)) type = 'article';
        else if (/\/pages\//.test(href)) type = 'page';
        var card = el.closest('product-card');
        push('search_result_click', {
          search_term: input ? input.value : '',
          result_type: type,
          source: 'predictive',
          product_id: card ? card.getAttribute('data-product-id') : '',
          product_handle: type === 'product' ? productHandle(href) : '',
          url: href,
        });
      },
    },

    /* Vysledky hledani - stranka /search */
    {
      sel: 'product-card a[href], .resource-card, .resource-card__link',
      when: function () {
        return cfg.template === 'search';
      },
      fn: function (el) {
        var card = el.closest('product-card');
        var p = card ? productFromCard(card) : { url: hrefOf(el) };
        p.search_term = cfg.search ? cfg.search.terms : '';
        p.source = 'search_page';
        p.result_type = card ? 'product' : 'other';
        push('search_result_click', p);
      },
    },

    /* Produkt v listingu / karuselu / menu */
    {
      sel: 'product-card a[href]',
      fn: function (el) {
        push('product_click', productFromCard(el.closest('product-card')));
      },
    },
    {
      sel: '.tk-mega-products__image, .tk-mega-products__title, .tk-mobile-drawer__product-img, .tk-mobile-drawer__product-title, .tk-reviews-preview__product',
      fn: function (el) {
        var href = hrefOf(el);
        var card = el.closest('.tk-mega-products__card, .tk-mobile-drawer__product, .tk-reviews-preview__product');
        /* karta v menu nese i hvězdy, sklad a tlačítko, název je jen v titulku */
        var title = card && card.querySelector('.tk-mega-products__title');
        push('product_click', {
          product_handle: productHandle(href),
          product_name: txt(title || card || el),
          list: el.classList.contains('tk-reviews-preview__product') ? 'reviews' : 'menu',
          url: href,
        });
      },
    },

    /* Kategorie - homepage swiper, dlazdice v kolekci, menu */
    {
      sel: '.tk-categories__card',
      fn: function (el) {
        var href = hrefOf(el);
        push('category_click', { source: 'homepage', category: collectionHandle(href) || slug(txt(el)), label: txt(el, 60), url: href });
      },
    },
    {
      sel: '.tk-coll-tile, .tk-promo-banner__tile',
      fn: function (el) {
        var href = hrefOf(el);
        push('category_click', {
          source: el.classList.contains('tk-coll-tile') ? 'listing' : 'homepage',
          category: collectionHandle(href) || slug(txt(el)),
          label: txt(el, 60),
          url: href,
        });
      },
    },
    {
      sel: '.tk-nav__link, a.tk-mega__brand, .tk-mega__title, .tk-mega__link, .tk-mega-simple__card, .tk-drawer-panel__item, .tk-mega-products__view-all, .tk-mega-banners__view-all',
      fn: function (el) {
        var href = hrefOf(el);
        var level = 'top';
        if (el.classList.contains('tk-mega__link') || el.classList.contains('tk-drawer-panel__item--sub')) level = 'sub';
        else if (el.classList.contains('tk-mega__title') || el.classList.contains('tk-mega-simple__card') || el.classList.contains('tk-drawer-panel__item')) level = 'category';
        push('category_click', {
          source: 'menu',
          menu_level: level,
          category: collectionHandle(href) || slug(txt(el)),
          label: txt(el, 60),
          url: href,
        });
      },
    },

    /* Galerie na PDP */
    {
      sel: 'media-gallery .slideshow-control, media-gallery .slideshow-controls__thumbnail',
      fn: function () {
        push('product_image_click', { type: 'thumbnail', product_id: cfg.product ? cfg.product.id : '' });
      },
    },
    {
      sel: 'media-gallery .product-media-container__zoom-button',
      fn: function () {
        push('product_image_click', { type: 'zoom', product_id: cfg.product ? cfg.product.id : '' });
      },
    },
    {
      sel: 'media-gallery .tk-gallery-video__facade',
      fn: function () {
        push('product_image_click', { type: 'video', product_id: cfg.product ? cfg.product.id : '' });
      },
    },
    {
      sel: '.lightbox-arrow',
      fn: function () {
        push('product_image_click', { type: 'lightbox_nav', product_id: cfg.product ? cfg.product.id : '' });
      },
    },
    {
      sel: 'media-gallery slideshow-slide, media-gallery .product-media',
      fn: function () {
        push('product_image_click', { type: 'slide', product_id: cfg.product ? cfg.product.id : '' });
      },
    },

    /* Obecne CTA ("Zobrazit vse", "Nakoupit", tlacitka sekci) */
    {
      sel: '.tk-promo-banner__shop-all, .tk-blog__header-link, .tk-rec__header-link, .tk-instagram__button, .tk-categories__view-all, .tk-mega-promo__btn, a.button, .tk-coll-banner__cta, .tk-usp-strip a, .tk-why-us a',
      when: function (el) {
        return !el.closest('product-card, cart-drawer-component, product-form-component, .tk-popup, .product-actions-dialog, .cart__ctas, form');
      },
      fn: function (el) {
        push('cta_click', { label: txt(el, 60), location: sectionId(el) || cfg.template, url: hrefOf(el) });
      },
    },
  ];

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      try {
        var decl = t.closest('[data-tk-ev]');
        if (decl) {
          push(decl.getAttribute('data-tk-ev'), evParams(decl));
          return;
        }
        for (var i = 0; i < RULES.length; i++) {
          var r = RULES[i];
          var el = t.closest(r.sel);
          if (!el) continue;
          if (r.when && !r.when(el, t)) continue;
          r.fn(el, t, e);
          return;
        }
      } catch (err) {
        if (debug) console.warn('[tk-track] click rule failed', err);
      }
    },
    true
  );

  /* ------------------------------------------------------------------ */
  /* Zobrazeni banneru (data-tk-view)                                     */
  /* ------------------------------------------------------------------ */
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var io = null;

  function visibleEnough(el) {
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var visH = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    var visW = Math.min(r.right, vw) - Math.max(r.left, 0);
    if (visH <= 0 || visW <= 0) return false;
    return (visH * visW) / (r.width * r.height) >= 0.5;
  }

  function fireView(el) {
    if (!seen || seen.has(el)) return;
    if (!visibleEnough(el)) return;
    seen.add(el);
    push(el.getAttribute('data-tk-view'), evParams(el));
  }

  function observeViews(root) {
    if (!('IntersectionObserver' in window) || !seen) return;
    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.5) fireView(en.target);
          });
        },
        { threshold: [0.5] }
      );
    }
    var els = root.querySelectorAll ? root.querySelectorAll('[data-tk-view]') : [];
    for (var i = 0; i < els.length; i++) io.observe(els[i]);
    if (root.matches && root.matches('[data-tk-view]')) io.observe(root);
  }

  function initViews() {
    observeViews(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes') {
          var t = m.target;
          if (t.hasAttribute && t.hasAttribute('data-tk-view') && t.getAttribute('aria-hidden') !== 'true') {
            requestAnimationFrame(function () {
              fireView(t);
            });
          }
          return;
        }
        for (var i = 0; i < m.addedNodes.length; i++) {
          var n = m.addedNodes[i];
          if (n.nodeType === 1) observeViews(n);
        }
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }

  /* ------------------------------------------------------------------ */
  /* Udalosti theme                                                       */
  /* ------------------------------------------------------------------ */
  var ADD_SOURCES = { 'product-form-component': 1, 'tk-fbt-add': 1, 'tk-chat': 1 };

  function cartItemInfo(item) {
    if (!item) return {};
    return {
      product_id: String(item.product_id || ''),
      variant_id: String(item.variant_id || item.id || ''),
      product_name: item.product_title || item.title || '',
      variant_name: item.variant_title || '',
      product_handle: item.handle || '',
      sku: item.sku || '',
      price: typeof item.price === 'number' ? item.price / 100 : undefined,
      vendor: item.vendor || '',
      product_type: item.product_type || '',
    };
  }

  function onCartUpdate(e) {
    var d = (e && e.detail) || {};
    var data = d.data || {};
    if (data.didError || !ADD_SOURCES[data.source]) return;
    var productId = data.productId ? String(data.productId) : '';
    var variantId = /^\d+$/.test(String(d.sourceId || '')) ? String(d.sourceId) : '';
    /* tk-chat posila v itemCount pocet kusu v CELEM kosiku, z chatu jde vzdy 1 ks */
    var qty = data.source === 'tk-chat' ? 1 : Number(data.itemCount) || 1;
    var src = data.source === 'tk-chat' ? 'chat' : d.sourceId && !variantId ? 'quick_add' : data.source === 'tk-fbt-add' ? 'fbt' : cfg.template === 'product' ? 'pdp' : 'quick_add';
    var base = {
      product_id: productId,
      variant_id: variantId,
      quantity: qty,
      currency: cfg.currency || '',
      source: src,
      location: cfg.template || '',
    };
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var item = null;
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (variantId && String(it.variant_id) === variantId) {
            item = it;
            break;
          }
          if (!variantId && productId && String(it.product_id) === productId) item = it;
        }
        var p = cartItemInfo(item);
        Object.keys(base).forEach(function (k) {
          if (base[k] !== '' && base[k] !== undefined) p[k] = base[k];
        });
        if (item && !p.variant_id) p.variant_id = String(item.variant_id);
        p.cart_total = cart && typeof cart.total_price === 'number' ? cart.total_price / 100 : undefined;
        p.cart_items = cart ? cart.item_count : undefined;
        push('add_to_cart_gtm', p);
      })
      .catch(function () {
        push('add_to_cart_gtm', base);
      });
  }

  function onCartError(e) {
    var d = (e && e.detail) || {};
    push('checkout_error', {
      step: 'add_to_cart',
      message: String(d.message || d.description || '').slice(0, 160),
      location: cfg.template || '',
    });
  }

  function onVariantUpdate(e) {
    var d = (e && e.detail) || {};
    var v = d.resource || {};
    if (!v.id) return;
    push('variant_selected', {
      product_id: String((d.data && d.data.productId) || (cfg.product && cfg.product.id) || ''),
      variant_id: String(v.id),
      variant_name: v.title || v.public_title || '',
      sku: v.sku || '',
      price: typeof v.price === 'number' ? v.price / 100 : undefined,
      available: !!v.available,
      currency: cfg.currency || '',
    });
  }

  /* Varianty MO nejsou nativni Shopify varianty, ale samostatne produkty
     (snippets/variant-switcher.liquid): klik na barvu/baleni = odkaz na jiny
     produkt a reload, variant:update nevznikne. Klik si proto ulozi do
     sessionStorage a variant_selected se posle az na cilovem PDP - push tesne
     pred odchodem ze stranky by GTM nemusel stihnout odeslat. */
  var SIB_KEY = 'tk_track_sib';

  function onSiblingClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-tk-sib-id]') : null;
    if (!a) return;
    var box = a.closest('[data-tk-color-switcher], [data-tk-variant-list]');
    var label = box ? box.querySelector('.tk-color-switcher__label, .tk-vsel__label') : null;
    /* Nazev osy bez textu aktualni barvy (span .tk-color-switcher__current v labelu) */
    var axis = label ? txt(label, 80) : '';
    var cur = label ? label.querySelector('.tk-color-switcher__current') : null;
    if (cur) axis = axis.replace(txt(cur, 80), '').trim();
    var val = a.querySelector('.tk-color-switcher__name, .tk-vsel__val');
    try {
      sessionStorage.setItem(
        SIB_KEY,
        JSON.stringify({
          to: a.getAttribute('data-tk-sib-id'),
          from: String((cfg.product && cfg.product.id) || ''),
          option_name: axis.slice(0, 40),
          option_value: txt(val, 60),
          ts: Date.now(),
        })
      );
    } catch (err) {}
  }

  function flushSibling() {
    var s = null;
    try {
      s = JSON.parse(sessionStorage.getItem(SIB_KEY) || 'null');
      sessionStorage.removeItem(SIB_KEY);
    } catch (err) {}
    var p = cfg.product;
    if (!s || !p || String(p.id) !== String(s.to) || Date.now() - s.ts > 60000) return;
    var v = p.variant || {};
    push('variant_selected', {
      product_id: String(p.id),
      product_name: p.title || '',
      from_product_id: s.from,
      variant_id: v.id ? String(v.id) : '',
      variant_name: s.option_value,
      option_name: s.option_name,
      sku: v.sku || '',
      price: typeof v.price === 'number' ? v.price / 100 : undefined,
      available: !!v.available,
      currency: cfg.currency || '',
      source: 'sibling',
    });
  }

  function onCoupon(e) {
    var d = (e && e.detail) || {};
    if (d.status === 'applied') push('coupon_applied', { code: d.code || '' });
    else if (d.status === 'error') push('coupon_error', { code: d.code || '', reason: d.reason || '' });
  }

  function onNewsletter(e) {
    var d = (e && e.detail) || {};
    push('newsletter_signup', { source: d.source || 'popup' });
  }

  function onToggle(e) {
    var el = e.target;
    if (!el || el.tagName !== 'DETAILS' || !el.open) return;
    var summary = el.querySelector('summary');
    var name = txt(summary, 60);
    push('accordion_open', { name: name, type: 'accordion', location: cfg.template || '' });
    if (/doprav|doru[cč]|dod[aá]n/i.test(name)) push('shipping_info_click', { source: 'accordion', name: name });
  }

  var drawerOpen = false;
  function watchCartDrawer() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var t = m.target;
        if (!t || t.tagName !== 'DIALOG' || !t.closest('cart-drawer-component')) return;
        var open = t.hasAttribute('open');
        if (open && !drawerOpen) push('checkout_step', { step: 1, step_name: 'cart_drawer', location: cfg.template || '' });
        drawerOpen = open;
      });
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }

  /* ------------------------------------------------------------------ */
  /* Filtry a razeni - diff URL parametru (Globo pushState / Tinker)      */
  /* ------------------------------------------------------------------ */
  function parseUrlState(href) {
    var f = {};
    var sort = '';
    try {
      var u = new URL(href, location.href);
      u.searchParams.forEach(function (v, k) {
        if (k === 'sort_by') {
          sort = v;
          return;
        }
        if (/^gf_/.test(k) || /^filter\./.test(k)) {
          f[k] = (f[k] || []).concat(String(v).split(','));
        }
      });
    } catch (e) {}
    return { f: f, sort: sort };
  }

  function filterName(key) {
    var id = key.replace(/^gf_/, '').replace(/^filter\./, '');
    var el =
      document.querySelector('.gf-option-block[data-id="' + id + '"] .gf-block-title, .gf-option-block[data-filter-id="' + id + '"] .gf-block-title, #gf-block-' + id + ' .gf-block-title') ||
      document.querySelector('[data-filter-key="' + key + '"] .gf-block-title');
    return el ? txt(el, 40) : '';
  }

  var urlState = parseUrlState(location.href);
  function onUrlChange() {
    var cur = parseUrlState(location.href);
    var prev = urlState;
    urlState = cur;
    if (cur.sort && cur.sort !== prev.sort) push('sort_used', { sort: cur.sort, location: cfg.collection || cfg.template });
    Object.keys(cur.f).forEach(function (k) {
      var before = prev.f[k] || [];
      var added = cur.f[k].filter(function (v) {
        return before.indexOf(v) < 0;
      });
      var removed = before.filter(function (v) {
        return cur.f[k].indexOf(v) < 0;
      });
      if (added.length) push('filter_used', { filter: k, filter_name: filterName(k), value: added.join(','), action: 'add', location: cfg.collection || cfg.template });
      if (removed.length) push('filter_used', { filter: k, filter_name: filterName(k), value: removed.join(','), action: 'remove', location: cfg.collection || cfg.template });
    });
    Object.keys(prev.f).forEach(function (k) {
      if (k in cur.f) return;
      push('filter_used', { filter: k, filter_name: filterName(k), value: prev.f[k].join(','), action: 'remove', location: cfg.collection || cfg.template });
    });
  }

  function hookHistory() {
    ['pushState', 'replaceState'].forEach(function (m) {
      var orig = history[m];
      if (typeof orig !== 'function') return;
      history[m] = function () {
        var r = orig.apply(this, arguments);
        setTimeout(onUrlChange, 0);
        return r;
      };
    });
    window.addEventListener('popstate', function () {
      setTimeout(onUrlChange, 0);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Start                                                                */
  /* ------------------------------------------------------------------ */
  function init() {
    document.addEventListener('cart:update', onCartUpdate);
    document.addEventListener('cart:error', onCartError);
    document.addEventListener('variant:update', onVariantUpdate);
    document.addEventListener('click', onSiblingClick, true);
    flushSibling();
    document.addEventListener('tk:coupon', onCoupon);
    document.addEventListener('tk:newsletter-signup', onNewsletter);
    document.addEventListener('toggle', onToggle, true);
    watchCartDrawer();
    hookHistory();
    initViews();

    if (cfg.template === 'search' && cfg.search) {
      push('search_gtm', { search_term: cfg.search.terms || '', results_count: cfg.search.count });
    }
    if (cfg.template === 'cart') {
      push('checkout_step', { step: 2, step_name: 'cart_page' });
    }
    if (document.querySelector('.email-signup__message--success')) {
      push('newsletter_signup', { source: 'footer' });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
